import React, { useState, useRef, useEffect } from "react";
import styles from "./styles.module.scss";
import ChevronDown from "../../../../../../assets/svg/icons/common/chevron";

const Select = ({
  value,
  options,
  onChange,
  indicatorColor,
  label,
  className = "",
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
  };

  return (
    <div className={styles.field} ref={selectRef}>
      {label && <label>{label}</label>}
      <div className={`${styles.selectContainer} ${className}`}>
        <button
          className={styles.selectButton}
          onClick={() => setIsOpen(!isOpen)}
          type="button"
        >
          {indicatorColor && (
            <span
              className={styles.statusIndicator}
              style={{ backgroundColor: indicatorColor }}
            />
          )}
          <span className={styles.value}>
            {options.find((option) => option.value == value)?.label ?? ""}
          </span>
          <ChevronDown
            className={`${styles.arrow} ${isOpen ? styles.open : ""}`}
          />
        </button>

        {isOpen && (
          <div className={styles.dropdown}>
            {options &&
              options.map((option) => (
                <button
                  key={`${option.label}-${option?.value}`}
                  className={`${styles.option} ${
                    value === option?.value ? styles.selected : ""
                  }`}
                  onClick={() => handleSelect(option?.value)}
                  type="button"
                >
                  {option.label}
                </button>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Select;
